// Guard against multiple definitions
if (!customElements.get('ucg-video')) {
  class ucgVideo extends HTMLElement {
    constructor() {
      super()
    }

    // Use connectedCallback instead of constructor to ensure DOM is ready
    connectedCallback() {
      // Small delay to ensure Swiper library and DOM are fully loaded
      setTimeout(() => {
        this.init();
      }, 100);
    }

    init() {
      this.clickAndDrag('.ugc-slide-wrapper');
      this.discriptionToggle();
      this.initSlide();
      this.closePopup();
      this.qntChange();
      this.variantChange();
      this.toggleSound();
      this.pdpOptMobile();
      this.handleAtc();
      this.cartTrigger();
    }

    initSlide() {
      // Scope to THIS instance
      const swiperEl = this.querySelector('.ugc-pop-slider .swiper');
      if (!swiperEl) {
        console.warn('Swiper element not found in this instance');
        return;
      }
      
      // Check if Swiper is available
      if (typeof Swiper === 'undefined') {
        console.error('Swiper library not loaded');
        return;
      }
      
      // Store swiper instance on the element
      this.swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        observer: true,
        direction: "horizontal",
        observeParents: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          768: {
            direction: 'horizontal',
            slidesPerView: 2,
            spaceBetween: 50,
            loop: true,
            navigation: {
              nextEl: this.querySelector(".swiper-nagivations .swiper-button-next"), 
              prevEl: this.querySelector(".swiper-nagivations .swiper-button-prev"),
            }
          }
        },
        on: {
          click: function() {
            this.slideTo(this.clickedIndex);
          }
        }
      })
      
      console.log('Swiper initialized for instance:', this.swiperInstance);
      
      this.playActiveVideo(this.swiperInstance); 
      this.onClickSlidePopup(this.swiperInstance);
    }

    playActiveVideo(swiper) {
      swiper.on('slideChange', () => {
        let videos = this.querySelectorAll('.ugc-pop-slider video');
        videos.forEach(video => {
          video.pause()
        });
        setTimeout(() => {
          const activeVideo = this.querySelector('.ugc-pop-slide-wrapper.swiper-slide.swiper-slide-active video');
          if (activeVideo) activeVideo.play();
        }, 100);
        setTimeout(() => {
          const prevVideo = this.querySelector('.ugc-pop-slide-wrapper.swiper-slide.swiper-slide-prev video');
          if (prevVideo) prevVideo.play();
        }, 100);
        setTimeout(() => {
          const nextVideo = this.querySelector('.ugc-pop-slide-wrapper.swiper-slide.swiper-slide-next video');
          if (nextVideo) nextVideo.play();
        }, 100);
      });
    }

    clickAndDrag(selector, scroll_speed = 2, classOnEvent = 'grabbed_elem') {
      const sliders = this.querySelectorAll(selector);
      if (!sliders.length) return;
      
      let isDown = false;
      let startX;
      let scrollLeft;
      sliders.forEach(slider => {
        slider.addEventListener('mousedown', (e) => {
            e.preventDefault();
            isDown = true;
            slider.classList.add(classOnEvent);
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        
            document.body.addEventListener('click', function( event ){
                if (slider.contains(event.target)) {
                    event.preventDefault();
                }
            });
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove(classOnEvent);
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove(classOnEvent);
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * scroll_speed;
            slider.scrollLeft = scrollLeft - walk;
        });
      });
    }

    discriptionToggle() {
      let readMoreBtns = this.querySelectorAll('.ugc-wrapper a.read-more');
      readMoreBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const descData = e.currentTarget.closest('.p-descriotion')?.querySelector('.desc-data');
          if (descData) {
            descData.classList.toggle('open');
            e.currentTarget.textContent = e.currentTarget.textContent == 'Read More' ? 'Read Less' : 'Read More';
          }
        })
      });
    }

    onClickSlidePopup(swiper) {
      let slides = this.querySelectorAll('.ugc-slide-wrapper .card-wrapper');
      const instance = this;
      
      console.log(`Found ${slides.length} slides in this instance`);
      
      slides.forEach(slide => {
        slide.addEventListener('click', (e) => {
          console.log('Slide clicked, opening popup for this instance');
          
          document.body.style.overflow = 'hidden';
          let curr_slide = parseInt(e.currentTarget.dataset.index);
          
          console.log('Current slide index:', curr_slide);
          
          // Set the swiper to the correct slide
          if (swiper && swiper.slideToLoop) {
            swiper.slideToLoop(curr_slide);
          } else if (swiper && swiper.slideTo) {
            swiper.slideTo(curr_slide);
          }
          
          // Query within THIS specific instance
          const popSlider = instance.querySelector('.ugc-pop-slider');
          console.log('Found popup slider:', popSlider);
          
          if (popSlider) {
            popSlider.classList.remove('is_hidden');
            console.log('✓ Removed is_hidden class from popup');
          } else {
            console.warn('❌ Popup slider not found in this instance');
          }
          
          document.querySelector('body').classList.add('shoppable-pop-up');
        })
      })
    }

    closePopup() {
      let popEle = this.querySelector('.popClose');
      if (!popEle) {
        console.warn('Close button not found in this instance');
        return;
      }
      
      popEle.addEventListener('click', (e) => {
        const popSlider = e.currentTarget.closest('.ugc-pop-slider');
        if (popSlider) {
          popSlider.classList.add('is_hidden');
        }
        document.querySelector('body')?.classList.remove('shoppable-pop-up');
        
        let contentWrappers = this.querySelectorAll('.ugc-pop-slide-wrapper .content-wrapper');
        document.body.style.overflow = null;
        contentWrappers.forEach(ele => {
          ele.classList.remove('active')
        });
      })
      
      let mobileOverlay = this.querySelectorAll('.content-wrapper .overlay');
      mobileOverlay.forEach(ele => {
        ele.addEventListener('click', (e) => {
          e.currentTarget.closest('.content-wrapper')?.classList.remove('active')
        })
      })
    }

    variantChange() {
      let variantRadios = this.querySelectorAll('.var-input');
      variantRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
          let that = e.currentTarget;
          const hiddenInput = that.closest('.variant-radio-wrapper')?.querySelector('[type="hidden"]');
          if (hiddenInput) hiddenInput.value = that.value;
          
          const productJsonEl = e.currentTarget.closest('.variant-opts')?.querySelector('[data-product-json]');
          if (!productJsonEl) return;
          
          let productJson = JSON.parse(productJsonEl.textContent);
          let varJson = productJson.variants;
          let valOption1 = that.closest('.variant-opts').querySelector('input[name="position_1"]');
          let valOption2 = that.closest('.variant-opts').querySelector('input[name="position_2"]');
          let valOption3 = that.closest('.variant-opts').querySelector('input[name="position_3"]');
          let atcBtn = that.closest('form')?.querySelector('[data-atc]');
          
          let currVarJSON = varJson.filter(item => {
            if (item?.option1 == valOption1?.value && item?.option2 == valOption2?.value && item?.option3 == valOption3?.value) {
              return item;
            }
          });
          currVarJSON = currVarJSON[0];
          
          const idInput = that.closest('.variant-opts')?.querySelector('[name="id"]');
          if (idInput && currVarJSON) {
            idInput.value = currVarJSON.id;
          }
          
          if (atcBtn && currVarJSON) {
            if (currVarJSON.available) {
              atcBtn.textContent = 'Add to cart';
              atcBtn.removeAttribute('disabled');
            } else {
              atcBtn.textContent = 'Sold out';
              atcBtn.setAttribute('disabled', '');
            }
          }
        })
      });
    }

    qntChange() {
      let incBtn = this.querySelectorAll('.qnt-wrapper .inc');
      let decBtn = this.querySelectorAll('.qnt-wrapper .dec');
      
      incBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let qntInput = e.currentTarget.closest('.qnt-wrapper')?.querySelector('[name="quantity"]');
          if (qntInput) {
            qntInput.value = parseInt(qntInput.value) + 1;
          }
        })
      })
      
      decBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let qntInput = e.currentTarget.closest('.qnt-wrapper')?.querySelector('[name="quantity"]');
          if (qntInput && qntInput.value > 1) {
            qntInput.value = parseInt(qntInput.value) - 1;
          }
        })
      })
    }

    toggleSound() {
      let toggleBtn = this.querySelectorAll('.ugc-wrapper .ugc-pop-slide-wrapper .volume-handle');
      toggleBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let video = e.currentTarget.closest('.video-wrapper')?.querySelector('video');
          if (video) {
            video.muted = !video.muted;
            e.currentTarget.classList.toggle('unmuted')
          }
        })
      })
    }

    pdpOptMobile() {
      let trigger = this.querySelectorAll('.action-wrapper [popup-trigger]');
      trigger.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let that = e.currentTarget;
          e.preventDefault();
          const contentWrapper = that.closest('.ugc-pop-slide-wrapper')?.querySelector('.content-wrapper');
          if (contentWrapper) {
            contentWrapper.classList.toggle('active');
            contentWrapper.querySelector('a')?.focus();
          }
        })
      })
    }

    cartTrigger() {
      const instance = this;
      const cartBtns = this.querySelectorAll('[data-cart]');
      
      cartBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          console.log('✓ Cart button clicked inside ucg-video');
          
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const href = btn.getAttribute('href');
          if (href) {
            btn.removeAttribute('href');
            console.log('Removed href:', href);
          }
          
          instance.openDrawerWithUpdate();
          
          return false;
        }, true);
      });
    }

    openDrawerWithUpdate() {
      fetch('/cart?section_id=quick-cart')
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newContainer = doc.querySelector('.quick-cart__container');
          const currentContainer = document.querySelector('.quick-cart__container');

          if (newContainer && currentContainer) {
            currentContainer.innerHTML = newContainer.innerHTML;
            console.log('✓ Updated cart container with new items');
          }

          const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
          const quickCart = document.querySelector('.quick-cart');
          
          if (quickCartWrapper) {
            quickCartWrapper.classList.add('active');
            console.log('✓ Added active class to .quick-cart__wrapper');
          }
          if (quickCart) {
            quickCart.classList.add('is-open');
            console.log('✓ Added is-open class to .quick-cart');
          }
          document.body.classList.add('js-drawer-open');
          console.log('✓ Added js-drawer-open to body');

          const countEl = doc.querySelector('.quick-cart__heading sup'); 
          if (countEl) {
            document.querySelectorAll('[data-js-cart-count]').forEach(el => {
              el.textContent = countEl.textContent;
            });
            console.log('✓ Updated cart count');
          }

          fetch('/cart.js')
            .then(r => r.json())
            .then(cartJson => {
              const total = cartJson.total_price;
              const container = document.querySelector('.quick-cart__container');
              if (container) {
                container.querySelectorAll('[data-free-shipping-bar]').forEach(el => {
                  el.setAttribute('data-cart-total', total);
                  el.dataset.cartTotal = total;
                });

                const quickAtcEl = document.querySelector('quick-atc');
                if (quickAtcEl && typeof quickAtcEl.freeShipStatus === 'function') {
                  quickAtcEl.freeShipStatus('.quick-cart__container .free-shipping-bar');
                } else if (typeof window.freeShipStatus === 'function') {
                  window.freeShipStatus('.quick-cart__container .free-shipping-bar');
                }
              }

              try {
                const evt = new CustomEvent('quick-cart:open', { detail: {} });
                document.dispatchEvent(evt);
                window.dispatchEvent(evt);
                console.log('✓ Dispatched quick-cart:open event');
              } catch (e) {
                console.warn('Could not dispatch quick-cart:open', e);
              }

              try { 
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartJson } })); 
              } catch (e) {}
              console.log('✓ Dispatched cart:updated event');
            })
            .catch(err => {
              console.warn('Could not refresh cart for drawer free-shipping bar', err);
              try { 
                document.dispatchEvent(new CustomEvent('quick-cart:open')); 
                window.dispatchEvent(new CustomEvent('quick-cart:open')); 
              } catch(e){}
              try { 
                document.dispatchEvent(new CustomEvent('cart:updated')); 
              } catch(e){}
            });
        })
        .catch(err => console.warn('Could not update quick cart', err));
    }

    handleAtc() {
      let atcBtns = this.querySelectorAll('[data-atc]');
      atcBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let that = e.currentTarget;
          e.preventDefault();
          e.stopPropagation();
          
          const form = that.closest('form');
          if (!form) return;
          
          let qntInput = form.querySelector('[name="quantity"]');
          let idInput = form.querySelector('[name="id"]');
          
          if (!qntInput || !idInput) return;
          
          let qnt = qntInput.value;
          let id = idInput.value;
          let bodyData = {"quantity": qnt, "id": id}
          
          that.setAttribute('disabled', '');
          fetch('/cart/add', {
            method: 'POST', 
            headers: {
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(bodyData)
          })
          .then(res => res.json())
          .then(res => {
            that.removeAttribute('disabled');
            let successMsg;
            if (res.status == 422) {
              successMsg = `<div class="atc-sucess">${res.description}</div>`;
            } else {
              successMsg = `<div class="atc-sucess">Product added to cart</div>`;
            }
            that.insertAdjacentHTML("afterend", successMsg);
            setTimeout(() => {
              that.nextSibling?.remove();  
            }, 2000);
            
            fetch('/cart.js')
              .then(r => r.json())
              .then(cartJson => {
                const total = cartJson.total_price; 
                document.querySelectorAll('[data-free-shipping-bar]').forEach(el => {
                  el.setAttribute('data-cart-total', total);
                  el.dataset.cartTotal = total;
                });

                const quickAtcEl = document.querySelector('quick-atc');
                if (quickAtcEl && typeof quickAtcEl.freeShipStatus === 'function') {
                  quickAtcEl.freeShipStatus('.free-shipping-bar');
                } else if (typeof window.freeShipStatus === 'function') {
                  window.freeShipStatus('.free-shipping-bar');
                }

                try { 
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartJson } })); 
                } catch (e) {}
              })
              .catch(err => console.warn('Could not refresh cart for free shipping bar', err));
          })
          .catch(err => console.log(err))
        })
      });
    }
  }

  customElements.define('ucg-video', ucgVideo);
}